import { useScroll, useTransform, MotionValue } from 'framer-motion';
import { RefObject } from 'react';

export function useParallax(
  ref: RefObject<HTMLElement>,
  speed: number = 0.2
): MotionValue<number> {
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"]
  });

  return useTransform(scrollYProgress, [0, 1], [-50 * speed, 50 * speed]);
}

// Soft ease-out curve for premium animations
export const softEaseOut = [0.22, 1, 0.36, 1] as const;
